import React, { useEffect, useState } from "react";
import { Receipt, Calendar } from "lucide-react";
import { portalApi } from "../../lib/portalApi";
import { brl } from "../../lib/format";
import { useI18n } from "../../i18n/I18nContext";

function fmt(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("en-US", {
    day: "2-digit", month: "short", year: "numeric",
  });
}

export default function PortalReceipts() {
  const { t } = useI18n();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await portalApi.get("/portal/receipts");
        setItems(data);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) return <div className="text-slate-500 text-sm">{t("Carregando…")}</div>;

  const total = items.reduce((acc, j) => acc + (Number(j.value) || 0), 0);

  if (items.length === 0) {
    return (
      <div className="space-y-5" data-testid="portal-receipts">
        <h1 className="text-2xl font-bold text-slate-900">{t("Recibos")}</h1>
        <div className="rounded-2xl border border-dashed border-slate-300 bg-white p-8 text-center text-slate-500">
          {t("Você ainda não tem serviços concluídos.")}
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-5" data-testid="portal-receipts">
      <h1 className="text-2xl font-bold text-slate-900">{t("Recibos")}</h1>

      <div className="rounded-2xl bg-gradient-to-br from-emerald-50 to-white border border-emerald-200 p-5">
        <div className="text-xs uppercase tracking-widest text-emerald-700 font-semibold">{t("Total pago")}</div>
        <div className="text-3xl font-bold text-emerald-800 mt-1">{brl(total)}</div>
        <div className="text-xs text-emerald-700/80 mt-1">{items.length} {t("serviços concluídos")}</div>
      </div>

      <ul className="space-y-3">
        {items.map((j) => (
          <li
            key={j.id}
            data-testid={`portal-receipt-${j.id}`}
            className="bg-white rounded-2xl border border-slate-200 p-4 flex flex-wrap items-center justify-between gap-3"
          >
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-emerald-50 border border-emerald-200 flex items-center justify-center text-emerald-700">
                <Receipt size={18} />
              </div>
              <div>
                <div className="text-sm font-semibold text-slate-900 flex items-center gap-1">
                  <Calendar size={13} /> {fmt(j.finished_at || j.scheduled_at)}
                </div>
                <div className="text-xs text-slate-600 truncate max-w-md">{j.address || "—"}</div>
              </div>
            </div>
            <div className="text-right">
              <div className="font-bold text-emerald-700 text-lg">{brl(j.value)}</div>
              <div className="text-[10px] uppercase tracking-widest text-slate-400">{t("Pago")}</div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
